const LABEL_OVERRIDES = {
  alarm: "Alarm",
  appliance: "Appliance",
  babybedroom: "Baby bedroom",
  balcony: "Balcony",
  bathhanger: "Bath hanger",
  bathub: "Bathtub",
  beachumbrella: "Beach umbrella",
  bed: "Bed",
  beddouble: "Double bed",
  blender: "Blender",
  breakfast: "Breakfast",
  campfire: "Campfire",
  cat: "Cat",
  cctv: "CCTV",
  childrenslide: "Children's slide",
  cleaningspray: "Cleaning spray",
  coffeemachine: "Coffee machine",
  dishes: "Dishes",
  dishwasher: "Dishwasher",
  dog: "Dog",
  dresserdrawer: "Dresser drawer",
  dressingmirror: "Dressing mirror",
  fairytale: "Fairy tale",
  fan: "Fan",
  fireextinguisher: "Fire extinguisher",
  forkknife: "Fork & knife",
  fridge: "Fridge",
  gamepad: "Gamepad",
  hairdryer: "Hair dryer",
  hanger: "Hanger",
  heating: "Heating",
  hotwater: "Hot water",
  housekey: "House key",
  induction: "Induction hob",
  kitchen: "Kitchen",
  laptoptable: "Laptop table",
  longterm: "Long-term stays",
  lounge: "Lounge",
  manstaff: "Male staff",
  medicalcase: "Medical kit",
  park: "Park access",
  platefork: "Plate & fork",
  safebox: "Safe box",
  saltpepper: "Salt & pepper",
  shower: "Shower",
  smoking: "Smoking allowed",
  soapdrop: "Soap",
  sofadouble: "Double sofa",
  stairs: "Stairs",
  stove: "Stove",
  sun: "Sun loungers",
  swimmingpool: "Swimming pool",
  swing: "Swing",
  tablechair: "Table & chair",
  toiletseat: "Toilet seat",
  toyscubes: "Toy cubes",
  trash: "Trash bins",
  trowelbrush: "Trowel brush",
  tvstand: "TV stand",
  userprofile: "Concierge support",
  valleyview: "Valley view",
  washingmachine: "Washing machine",
  wifi: "Wi-Fi",
  wineglass: "Wine glass",
  womenstaff: "Female staff",
  workjob: "Workspace",
};

const humanize = (input = "") =>
  input
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim();

const titleCase = (input = "") =>
  humanize(input)
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

export const getAmenityLabel = (value) => {
  if (!value) return "";
  if (LABEL_OVERRIDES[value]) return LABEL_OVERRIDES[value];
  return titleCase(value);
};

export const countSelectedAmenities = (amenities = {}) =>
  Object.values(amenities).reduce(
    (total, list) => total + (Array.isArray(list) ? list.length : 0),
    0
  );


